import React, { FC } from 'react';

import { Box, Stack } from '@mui/material';
import { Bell } from 'phosphor-react';

import { useNotifications } from '~components/hooks/notifications/useNotifications';
import { FullWidthDivider } from '~components/shared/divider';
import { primaryColors } from '~components/theme/styles/colors';
import { hideScrollbar } from '~components/theme/styles/mixins';

import { AccountPanel } from './accountPanel';

export const AccountDialAnnouncements: FC<{ forceOpen?: boolean }> = ({ forceOpen }) => {
  const { notificationsComponents } = useNotifications();
  return (
    <AccountPanel
      titleContent="ANNOUNCEMENTS"
      titleIcon={<Bell size={22} color={primaryColors[400]} />}
      forceOpen={forceOpen}
      panelBodySx={{ padding: '0px 32px' }}
    >
      <Stack sx={{ maxHeight: '459px', ...hideScrollbar }}>
        {notificationsComponents.map((notif, index) => (
          <Box key={index}>
            <Box sx={{ padding: '24px 0' }}>{notif}</Box>
            {index !== notificationsComponents.length - 1 && (
              <FullWidthDivider offsetPadding={24} sx={{ margin: 0 }} />
            )}
          </Box>
        ))}
      </Stack>
    </AccountPanel>
  );
};
